import {
  SET_DASHBOARD_MODAL_VISIBILITY,
  SET_MAINTENANCE_DASHBOARD_MODAL_VISIBILITY,
  SET_CUSTOMER_DASHBOARD_MODAL_VISIBILITY,
  SET_CAME_FROM_CUSTOMER_DASHBOARD,
  FETCH_CUSTOMER_DASHBOARD_DATA_REQUEST,
  FETCH_CUSTOMER_DASHBOARD_DATA_SUCCESS,
  FETCH_CUSTOMER_DASHBOARD_DATA_FAILURE,
  FETCH_DASHBOARD_STATS_REQUEST,
  FETCH_DASHBOARD_STATS_SUCCESS,
  FETCH_DASHBOARD_STATS_FAILURE,
  FETCH_DASHBOARD_WEEKLY_STATS_REQUEST,
  FETCH_DASHBOARD_WEEKLY_STATS_SUCCESS,
  FETCH_DASHBOARD_WEEKLY_STATS_FAILURE,
  FETCH_DASHBOARD_REPORT_REQUEST,
  FETCH_DASHBOARD_REPORT_SUCCESS,
  FETCH_DASHBOARD_REPORT_FAILURE,
  FETCH_OPERATIONAL_ALERTS_REQUEST,
  FETCH_OPERATIONAL_ALERTS_SUCCESS,
  FETCH_OPERATIONAL_ALERTS_FAILURE,
  FETCH_ALERTS_HISTORY_QUARTERLY_REQUEST,
  FETCH_ALERTS_HISTORY_QUARTERLY_SUCCESS,
  FETCH_ALERTS_HISTORY_QUARTERLY_FAILURE,
  FETCH_ALERTS_LIFECYCLE_QUARTERLY_REQUEST,
  FETCH_ALERTS_LIFECYCLE_QUARTERLY_SUCCESS,
  FETCH_ALERTS_LIFECYCLE_QUARTERLY_FAILURE,
  FETCH_ALERTS_YEARLY_TREND_REQUEST,
  FETCH_ALERTS_YEARLY_TREND_SUCCESS,
  FETCH_ALERTS_YEARLY_TREND_FAILURE,
  FETCH_OPERATIONAL_ALERTS_SETTINGS_REQUEST,
  FETCH_OPERATIONAL_ALERTS_SETTINGS_SUCCESS,
  FETCH_OPERATIONAL_ALERTS_SETTINGS_FAILURE,
  UPDATE_OPERATIONAL_ALERTS_SETTINGS_REQUEST,
  UPDATE_OPERATIONAL_ALERTS_SETTINGS_SUCCESS,
  UPDATE_OPERATIONAL_ALERTS_SETTINGS_FAILURE,
  FETCH_CUSTOMER_LOGO_REQUEST,
  FETCH_CUSTOMER_LOGO_SUCCESS,
  FETCH_CUSTOMER_LOGO_FAILURE,
  FETCH_DEVICE_TYPES_STATS_WEEKLY_REQUEST,
  FETCH_DEVICE_TYPES_STATS_WEEKLY_SUCCESS,
  FETCH_DEVICE_TYPES_STATS_WEEKLY_FAILURE,
  FETCH_MAINTENANCE_DASHBOARD_REQUEST,
  FETCH_MAINTENANCE_DASHBOARD_SUCCESS,
  FETCH_MAINTENANCE_DASHBOARD_FAILURE,
  FETCH_MAINTENANCE_REPORT_SENSORS_REQUEST,
  FETCH_MAINTENANCE_REPORT_SENSORS_SUCCESS,
  FETCH_MAINTENANCE_REPORT_SENSORS_FAILURE,
} from '../actions/DashboardActions';
import {
  SET_AUTO_RECOMMENDED_ALERTS_MODAL_VISIBILITY,
  FETCH_AUTO_RECOMMENDED_ALERTS_REQUEST,
  FETCH_AUTO_RECOMMENDED_ALERTS_SUCCESS,
  FETCH_AUTO_RECOMMENDED_ALERTS_FAILURE,
  CHANGE_AUTO_ALERT_STATE_REQUEST,
  CHANGE_AUTO_ALERT_STATE_SUCCESS,
  CHANGE_AUTO_ALERT_STATE_FAILURE,
  CHANGE_AUTO_ALERT_PRIORITY_REQUEST,
  CHANGE_AUTO_ALERT_PRIORITY_SUCCESS,
  CHANGE_AUTO_ALERT_PRIORITY_FAILURE,
  ADD_AUTO_ALERT_FEEDBACK_REQUEST,
  ADD_AUTO_ALERT_FEEDBACK_SUCCESS,
  ADD_AUTO_ALERT_FEEDBACK_FAILURE,
  FETCH_AUTO_ALERT_HISTORY_REQUEST,
  FETCH_AUTO_ALERT_HISTORY_SUCCESS,
  FETCH_AUTO_ALERT_HISTORY_FAILURE,
} from '../actions/AutoRecommendedAlertsActions';

const initialState = {
  modalVisible: false,
  maintenanceDashboardModalVisible: false,
  stats: {
    data: null,
    loading: false,
    error: null,
  },
  weeklyStats: {
    data: null,
    loading: false,
    error: null,
  },
  reports: {
    sensorActivity: {
      data: null,
      loading: false,
      error: null,
    },
    sensorActivityByType: {
      data: null,
      loading: false,
      error: null,
    },
    sensorIssues: {
      data: null,
      loading: false,
      error: null,
    },
    alertReport: {
      data: null,
      loading: false,
      error: null,
    },
    sensorFmIssues: {
      data: null,
      loading: false,
      error: null,
    },
  },
  operationalAlerts: {
    data: null,
    loading: false,
    error: null,
  },
  alertsHistoryQuarterly: {
    data: null,
    loading: false,
    error: null,
  },
  alertsLifecycleQuarterly: {
    data: null,
    loading: false,
    error: null,
  },
  alertsYearlyTrend: {
    data: null,
    loading: false,
    error: null,
  },
  operationalAlertsSettings: {
    data: null,
    loading: false,
    error: null,
    updating: false,
  },
  customerLogo: {
    data: null,
    loading: false,
    error: null,
  },
  deviceTypesStatsWeekly: {
    data: null,
    loading: false,
    error: null,
  },
  maintenanceDashboard: {
    data: null,
    loading: false,
    error: null,
  },
  maintenanceReportSensors: {
    data: null,
    reportType: null,
    loading: false,
    error: null,
  },
  customerDashboardModalVisible: false,
  cameFromCustomerDashboard: false,
  customerDashboardData: {
    data: null,
    loading: false,
    error: null,
  },
  autoRecommendedAlertsModalVisible: false,
  autoRecommendedAlerts: {
    data: [],
    loading: false,
    error: null,
  },
  autoRecommendedAlertHistory: {
    data: [],
    loading: false,
    error: null,
  },
};

export default function dashboardReducer(state = initialState, action) {
  switch (action.type) {
    // Modal Visibility
    case SET_DASHBOARD_MODAL_VISIBILITY:
      return {
        ...state,
        modalVisible: action.payload,
      };

    case SET_MAINTENANCE_DASHBOARD_MODAL_VISIBILITY:
      return {
        ...state,
        maintenanceDashboardModalVisible: action.payload,
      };

    case SET_AUTO_RECOMMENDED_ALERTS_MODAL_VISIBILITY:
      return {
        ...state,
        autoRecommendedAlertsModalVisible: action.payload,
      };

    case FETCH_AUTO_RECOMMENDED_ALERTS_REQUEST:
      return {
        ...state,
        autoRecommendedAlerts: {
          ...state.autoRecommendedAlerts,
          loading: true,
          error: null,
        },
      };
    case FETCH_AUTO_RECOMMENDED_ALERTS_SUCCESS:
      return {
        ...state,
        autoRecommendedAlerts: {
          data: action.payload || [],
          loading: false,
          error: null,
        },
      };
    case FETCH_AUTO_RECOMMENDED_ALERTS_FAILURE:
      return {
        ...state,
        autoRecommendedAlerts: {
          ...state.autoRecommendedAlerts,
          loading: false,
          error: action.error,
        },
      };

    case FETCH_AUTO_ALERT_HISTORY_REQUEST:
      return {
        ...state,
        autoRecommendedAlertHistory: {
          ...state.autoRecommendedAlertHistory,
          loading: true,
          error: null,
        },
      };
    case FETCH_AUTO_ALERT_HISTORY_SUCCESS:
      return {
        ...state,
        autoRecommendedAlertHistory: {
          data: action.payload || [],
          loading: false,
          error: null,
        },
      };
    case FETCH_AUTO_ALERT_HISTORY_FAILURE:
      return {
        ...state,
        autoRecommendedAlertHistory: {
          ...state.autoRecommendedAlertHistory,
          loading: false,
          error: action.error,
        },
      };

    // Write requests/failures don't hold their own slice; surfaced via the
    // re-fetch (success) and via the dialog's own response handling (failure).
    case CHANGE_AUTO_ALERT_STATE_REQUEST:
    case CHANGE_AUTO_ALERT_STATE_SUCCESS:
    case CHANGE_AUTO_ALERT_STATE_FAILURE:
    case CHANGE_AUTO_ALERT_PRIORITY_REQUEST:
    case CHANGE_AUTO_ALERT_PRIORITY_SUCCESS:
    case CHANGE_AUTO_ALERT_PRIORITY_FAILURE:
    case ADD_AUTO_ALERT_FEEDBACK_REQUEST:
    case ADD_AUTO_ALERT_FEEDBACK_SUCCESS:
    case ADD_AUTO_ALERT_FEEDBACK_FAILURE:
      return state;

    // Dashboard Stats
    case FETCH_DASHBOARD_STATS_REQUEST:
      return {
        ...state,
        stats: {
          ...state.stats,
          loading: true,
          error: null,
        },
      };

    case FETCH_DASHBOARD_STATS_SUCCESS:
      return {
        ...state,
        stats: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };

    case FETCH_DASHBOARD_STATS_FAILURE:
      return {
        ...state,
        stats: {
          ...state.stats,
          loading: false,
          error: action.error,
        },
      };

    // Weekly Stats
    case FETCH_DASHBOARD_WEEKLY_STATS_REQUEST:
      return {
        ...state,
        weeklyStats: {
          ...state.weeklyStats,
          loading: true,
          error: null,
        },
      };

    case FETCH_DASHBOARD_WEEKLY_STATS_SUCCESS:
      return {
        ...state,
        weeklyStats: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };

    case FETCH_DASHBOARD_WEEKLY_STATS_FAILURE:
      return {
        ...state,
        weeklyStats: {
          ...state.weeklyStats,
          loading: false,
          error: action.error,
        },
      };

    // Reports
    case FETCH_DASHBOARD_REPORT_REQUEST:
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.reportType]: {
            ...state.reports[action.reportType],
            loading: true,
            error: null,
          },
        },
      };

    case FETCH_DASHBOARD_REPORT_SUCCESS:
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.reportType]: {
            data: action.payload,
            loading: false,
            error: null,
          },
        },
      };

    case FETCH_DASHBOARD_REPORT_FAILURE:
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.reportType]: {
            ...state.reports[action.reportType],
            loading: false,
            error: action.error,
          },
        },
      };

    // Operational Alerts
    case FETCH_OPERATIONAL_ALERTS_REQUEST:
      return {
        ...state,
        operationalAlerts: {
          ...state.operationalAlerts,
          loading: true,
          error: null,
        },
      };

    case FETCH_OPERATIONAL_ALERTS_SUCCESS:
      return {
        ...state,
        operationalAlerts: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };

    case FETCH_OPERATIONAL_ALERTS_FAILURE:
      return {
        ...state,
        operationalAlerts: {
          ...state.operationalAlerts,
          loading: false,
          error: action.error,
        },
      };

    // Alerts History Quarterly
    case FETCH_ALERTS_HISTORY_QUARTERLY_REQUEST:
      return {
        ...state,
        alertsHistoryQuarterly: {
          ...state.alertsHistoryQuarterly,
          loading: true,
          error: null,
        },
      };

    case FETCH_ALERTS_HISTORY_QUARTERLY_SUCCESS:
      return {
        ...state,
        alertsHistoryQuarterly: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };

    case FETCH_ALERTS_HISTORY_QUARTERLY_FAILURE:
      return {
        ...state,
        alertsHistoryQuarterly: {
          ...state.alertsHistoryQuarterly,
          loading: false,
          error: action.error,
        },
      };

    // Alerts Lifecycle Quarterly
    case FETCH_ALERTS_LIFECYCLE_QUARTERLY_REQUEST:
      return {
        ...state,
        alertsLifecycleQuarterly: {
          ...state.alertsLifecycleQuarterly,
          loading: true,
          error: null,
        },
      };

    case FETCH_ALERTS_LIFECYCLE_QUARTERLY_SUCCESS:
      return {
        ...state,
        alertsLifecycleQuarterly: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };

    case FETCH_ALERTS_LIFECYCLE_QUARTERLY_FAILURE:
      return {
        ...state,
        alertsLifecycleQuarterly: {
          ...state.alertsLifecycleQuarterly,
          loading: false,
          error: action.error,
        },
      };

    // Alerts Yearly Trend
    case FETCH_ALERTS_YEARLY_TREND_REQUEST:
      return {
        ...state,
        alertsYearlyTrend: {
          ...state.alertsYearlyTrend,
          loading: true,
          error: null,
        },
      };

    case FETCH_ALERTS_YEARLY_TREND_SUCCESS:
      return {
        ...state,
        alertsYearlyTrend: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };

    case FETCH_ALERTS_YEARLY_TREND_FAILURE:
      return {
        ...state,
        alertsYearlyTrend: {
          ...state.alertsYearlyTrend,
          loading: false,
          error: action.error,
        },
      };

    // Operational Alerts Settings
    case FETCH_OPERATIONAL_ALERTS_SETTINGS_REQUEST:
      return {
        ...state,
        operationalAlertsSettings: {
          ...state.operationalAlertsSettings,
          loading: true,
          error: null,
        },
      };

    case FETCH_OPERATIONAL_ALERTS_SETTINGS_SUCCESS:
      return {
        ...state,
        operationalAlertsSettings: {
          data: action.payload,
          loading: false,
          error: null,
          updating: false,
        },
      };

    case FETCH_OPERATIONAL_ALERTS_SETTINGS_FAILURE:
      return {
        ...state,
        operationalAlertsSettings: {
          ...state.operationalAlertsSettings,
          loading: false,
          error: action.error,
        },
      };

    case UPDATE_OPERATIONAL_ALERTS_SETTINGS_REQUEST:
      return {
        ...state,
        operationalAlertsSettings: {
          ...state.operationalAlertsSettings,
          updating: true,
          error: null,
        },
      };

    case UPDATE_OPERATIONAL_ALERTS_SETTINGS_SUCCESS:
      return {
        ...state,
        operationalAlertsSettings: {
          data: action.payload,
          loading: false,
          error: null,
          updating: false,
        },
      };

    case UPDATE_OPERATIONAL_ALERTS_SETTINGS_FAILURE:
      return {
        ...state,
        operationalAlertsSettings: {
          ...state.operationalAlertsSettings,
          updating: false,
          error: action.error,
        },
      };

    // Customer Logo
    case FETCH_CUSTOMER_LOGO_REQUEST:
      return {
        ...state,
        customerLogo: {
          ...state.customerLogo,
          loading: true,
          error: null,
        },
      };

    case FETCH_CUSTOMER_LOGO_SUCCESS:
      return {
        ...state,
        customerLogo: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };

    case FETCH_CUSTOMER_LOGO_FAILURE:
      return {
        ...state,
        customerLogo: {
          data: null,
          loading: false,
          error: action.error,
        },
      };

    // Device Types Stats Weekly
    case FETCH_DEVICE_TYPES_STATS_WEEKLY_REQUEST:
      return {
        ...state,
        deviceTypesStatsWeekly: {
          ...state.deviceTypesStatsWeekly,
          loading: true,
          error: null,
        },
      };

    case FETCH_DEVICE_TYPES_STATS_WEEKLY_SUCCESS:
      return {
        ...state,
        deviceTypesStatsWeekly: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };

    case FETCH_DEVICE_TYPES_STATS_WEEKLY_FAILURE:
      return {
        ...state,
        deviceTypesStatsWeekly: {
          ...state.deviceTypesStatsWeekly,
          loading: false,
          error: action.error,
        },
      };

    case FETCH_MAINTENANCE_DASHBOARD_REQUEST:
      return {
        ...state,
        maintenanceDashboard: {
          ...state.maintenanceDashboard,
          loading: true,
          error: null,
        },
      };

    case FETCH_MAINTENANCE_DASHBOARD_SUCCESS:
      return {
        ...state,
        maintenanceDashboard: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };

    case FETCH_MAINTENANCE_DASHBOARD_FAILURE:
      return {
        ...state,
        maintenanceDashboard: {
          ...state.maintenanceDashboard,
          loading: false,
          error: action.error,
        },
      };

    case FETCH_MAINTENANCE_REPORT_SENSORS_REQUEST:
      return {
        ...state,
        maintenanceReportSensors: {
          ...state.maintenanceReportSensors,
          loading: true,
          error: null,
        },
      };

    case FETCH_MAINTENANCE_REPORT_SENSORS_SUCCESS:
      return {
        ...state,
        maintenanceReportSensors: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };

    case FETCH_MAINTENANCE_REPORT_SENSORS_FAILURE:
      return {
        ...state,
        maintenanceReportSensors: {
          ...state.maintenanceReportSensors,
          loading: false,
          error: action.error,
        },
      };

    // Customer Dashboard Modal
    case SET_CUSTOMER_DASHBOARD_MODAL_VISIBILITY:
      return {
        ...state,
        customerDashboardModalVisible: action.payload,
        cameFromCustomerDashboard: action.payload
          ? state.cameFromCustomerDashboard
          : false,
      };

    case SET_CAME_FROM_CUSTOMER_DASHBOARD:
      return {
        ...state,
        cameFromCustomerDashboard: action.payload,
      };

    // Customer Dashboard Data
    case FETCH_CUSTOMER_DASHBOARD_DATA_REQUEST:
      return {
        ...state,
        customerDashboardData: {
          ...state.customerDashboardData,
          loading: true,
          error: null,
        },
      };

    case FETCH_CUSTOMER_DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        customerDashboardData: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };

    case FETCH_CUSTOMER_DASHBOARD_DATA_FAILURE:
      return {
        ...state,
        customerDashboardData: {
          ...state.customerDashboardData,
          loading: false,
          error: action.error,
        },
      };

    default:
      return state;
  }
}
